import type { ReactElement, SVGProps } from "react";

/**
 * The sidebar's open/close mark: a panel with its left column drawn in.
 *
 * Saket's rule for icons here — raw SVG props (width/height), never a `size`
 * prop, so a caller can size it inline like any other element.
 */
export function SidebarPanelIcon(props: SVGProps<SVGSVGElement>): ReactElement {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
      {...props}
    >
      <rect x="3" y="4" width="18" height="16" rx="2" />
      <path d="M9 4v16" />
    </svg>
  );
}
